// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2JFo2","footer":"ModalError_footer__3uhpF"};